import React, { createContext, useContext, useState } from 'react';

import { GetHelpModal } from './GetHelpModal';
import { LanguageAndCurrencyModal } from './LanguageAndCurrencyModal';

type TGlobalHeaderMenuContext = {
  closeMenu: () => void;
  openLanguageAndCurrencyModal: () => void;
  openGetHelpModal: () => void;
};

const GlobalHeaderMenuContext = createContext<TGlobalHeaderMenuContext>({
  closeMenu: () => {},
  openLanguageAndCurrencyModal: () => {},
  openGetHelpModal: () => {},
});

export const useGlobalHeaderMenuContext = () => useContext(GlobalHeaderMenuContext);

type TGlobalHeaderMenuProviderProps = {
  onClose: () => void;
  children: React.ReactNode;
};

export const GlobalHeaderMenuProvider = ({ onClose, children }: TGlobalHeaderMenuProviderProps) => {
  const [isLanguageCurrencyModalOpen, setIsLanguageCurrencyModalOpen] = useState(false);
  const [isGetHelpModalOpen, setIsGetHelpModalOpen] = useState(false);

  return (
    <GlobalHeaderMenuContext.Provider
      value={{
        closeMenu: onClose,
        openLanguageAndCurrencyModal: () => setIsLanguageCurrencyModalOpen(true),
        openGetHelpModal: () => setIsGetHelpModalOpen(true),
      }}>
      {children}
      <LanguageAndCurrencyModal
        isOpen={isLanguageCurrencyModalOpen}
        onClose={() => setIsLanguageCurrencyModalOpen(false)}
      />
      <GetHelpModal isOpen={isGetHelpModalOpen} onClose={() => setIsGetHelpModalOpen(false)} />
    </GlobalHeaderMenuContext.Provider>
  );
};
